<template>
	<div v-if="currentUser">

		<div class="flex my-6">
			<div class="w-4/12">
				<table class="mb-4">
					<tr>
						<td class="pr-4">Default time from:</td>
						<td>
							<div>
								<select class="form-input w-auto mr-1" v-model="currentUser.hourFrom">
									<option :value="hour" v-for="hour in 23">{{ hour | nullerize }}</option>
								</select>:
								<select class="form-input w-auto" v-model="currentUser.minFrom">
									<option
										:value="minute"
										v-if="(minute % 5) == 0"
										v-for="(i, minute) in 60"
									>{{ minute | nullerize }}</option>
								</select>
							</div>
						</td>
					</tr>
				</table>
		
				<div class="flex my-6">
					<button class="btn btn-secondary" @click="saveSettings">
						<div v-if="loading" class="loader"></div>
						<span v-else>Save</span>
					</button>
				</div>
			</div>
	
			<div class="w-4/12">
	
				<form @submit.prevent="passwordModal = true" action="#" class="mt-2">
					<div class="flex items-center my-2">
						<div class="w-4/12">Change password:</div>
						<div class="w-5/12">
							<input v-model="user.password" class="form-input w-full" type="password" placeholder="Enter new password" required minlength="6" />
						</div>
						<div class="w-2/12">
							<button class="btn btn-small btn-secondary ml-4" type="submit">Change</button>
						</div>
					</div>
				</form>
	
			</div>
		</div>

		<SimpleModal v-if="passwordModal" @action="changePassword" @close="passwordModal = false" :btnClass="'btn-secondary'">
            <template v-slot:title>Change password</template>
            <template v-slot:body>Are you sure you want to change the password?</template>
            <template v-slot:button>Change</template>
        </SimpleModal>

	</div>
</template>

<script>
import { mapState } from "vuex";
import { db, auth } from "@/firebase";
import axios from 'axios'

import SimpleModal from '@/components/SimpleModal.vue'

export default {
	data() {
		return {
			loading: 0,
			passwordModal: false,
			user: {
				password: null
			}
		};
	},

	computed: {
		...mapState({
			currentUser: state => state.user.info
		})
	},

	components: {
		SimpleModal
	},

	methods: {
		saveSettings() {
			this.loading = 1;
			
			db
			.collection("users")
			.doc(auth.currentUser.uid)
			.update(this.currentUser)
			.then(() => {
				this.loading = 0;
				this.$toasted.show("Saved successfully!", {
					type: 'success'
				})
			})
			.catch(error => {
				this.loading = 0;
				this.$toasted.show(`Error: ${error}`, {
					type: 'error'
				})
			});
		},

		changePassword() {
			axios(
				{
					method: 'put',
					url: `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/user`,
					auth: {
						username: process.env.VUE_APP_CLOUD_FUNCTIONS_USERNAME,
						password: process.env.VUE_APP_CLOUD_FUNCTIONS_PASSWORD
					},
					data: {
						uid: auth.currentUser.uid,
						data: {
							password: this.user.password
						}
					}
				}
			)
			.then(res => {
				if (res.data.updated) {
					this.passwordModal = 0;
					this.$toasted.show('Password was changed successfully!', {
						type: 'success'
					})
				} else {
					this.passwordModal = 0;
					this.$toasted.show(res.data.message, {
						type: 'error'
					})
				}
			})
			.catch(error => {
				this.passwordModal = 0;
				this.$toasted.show(error, {
					type: 'error'
				})
			})
		}
	},

	filters: {
		nullerize(hour) {
			return hour < 10 ? "0" + hour : hour;
		}
	},

	created() {
		this.$store.commit('SET_TITLE', 'My Profile')
	}
};
</script>